import { useNoPhoneCodes } from "Flocknote/stateHooks";

import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { variants } from "Login/TwoFA/constants";

const useFirstFactorVerbiage = () => {
  const { variant } = useTwoFAContext();
  const noPhoneCodes = useNoPhoneCodes();

  switch (variant) {
    case variants.login:
      if (noPhoneCodes) return "Enter your email to get logged in.";
      return "Enter your email or phone number to get logged in.";
    case variants.give:
      return "Let's verify your info";
    default:
      return "";
  }
};

export { useFirstFactorVerbiage };
